(function () {
    'use strict';
    
    angular.module("imApp").factory("custactCalcJobExitService", ['$ihttp', function ($ihttp) {
        let service = {
            loaded: false,
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 884,
                    parameters: parms || {}
                });
            },
            listFinishedJobs: function (parms) {
                return $ihttp.post({
                    method: 882,
                    parameters: parms || {}
                });
            },
            setCustactNo: function (menu) {
                return $ihttp.post({
                    method: 883,
                    parameters: menu
                });
            }
        };
        
        return service;
    }]);
})();
